/**
 * Line separator character, used for multiline text.
 */
export var LINE_SEPARATOR = "\u2028";
/**
 * Object replacement character, used as a placeholder for objects.
 */

export var OBJECT_REPLACEMENT_CHARACTER = "\uFFFC";
/**
 * Zero width non-breaking space, used as padding in the editable DOM tree when
 * it is empty otherwise.
 */

export var ZWNBSP = "\uFEFF";
//# sourceMappingURL=special-characters.js.map